import { api } from '../api/client';

export type PlanCode = 'STANDARD' | 'TEACHER' | 'ENTERPRISE';

export type SubscriptionPrice = {
  plan: PlanCode;
  maxLearners: number;
  unitAmount: number;
  currency: string;
  interval: string;
  intervalCount: number;
};

export const PLAN_LABEL: Record<PlanCode, string> = {
  STANDARD: 'Standard',
  TEACHER: 'Teacher',
  ENTERPRISE: 'Enterprise',
};

export async function fetchPrice(): Promise<SubscriptionPrice | null> {
  const p = await api<SubscriptionPrice | undefined>('/subscription/price', { token: true });
  return p ?? null;
}

export async function fetchPlans(): Promise<SubscriptionPrice[]> {
  const list = await api<SubscriptionPrice[] | undefined>('/subscription/plans', { token: true });
  return list ?? [];
}

export function formatPrice(p: SubscriptionPrice): string {
  const currency = p.currency.toUpperCase();
  const fmt = new Intl.NumberFormat(undefined, { style: 'currency', currency });
  const digits = fmt.resolvedOptions().maximumFractionDigits ?? 2;
  const amount = fmt.format(p.unitAmount / 10 ** digits);
  const every = p.intervalCount === 1 ? p.interval : `${p.intervalCount} ${p.interval}s`;
  return `${amount} per ${every}`;
}
